var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22265 20.5723C13.5347 20.5723 17.0303 17.0767 17.0303 12.7646C17.0303 8.45262 13.5347 4.95703 9.22265 4.95703C4.91063 4.95703 1.41504 8.45262 1.41504 12.7646C1.41504 17.0767 4.91063 20.5723 9.22265 20.5723Z",
    fill: "#B0EF8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31115 18.8048L9.21212 18.6361C7.69943 16.0588 3.67964 10.5893 3.63904 10.5344L3.58105 10.4556L4.95057 9.10212L9.28572 12.1292C12.0152 8.58727 14.5617 6.15449 16.2227 4.73384C18.0398 3.17979 19.2226 2.46436 19.2345 2.45751L19.2614 2.44141H21.5845L21.3626 2.63903C15.6555 7.7223 9.46967 18.5263 9.40806 18.6348L9.31115 18.8048Z",
    fill: "#009045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedSign);
export default __webpack_public_path__ + "static/media/checked_sign.e6a87f7260ae4a3a37d33a00f6151406.svg";
export { ForwardRef as ReactComponent };